import { render, staticRenderFns } from "./CreateLibraryDataModal.vue?vue&type=template&id=5fa3acbf&scoped=true&"
import script from "./CreateLibraryDataModal.vue?vue&type=script&lang=js&"
export * from "./CreateLibraryDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa3acbf",
  null
  
)

export default component.exports